function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "188",
  height: "126",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_729_30)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M175.544 113.78a5.052 5.052 0 01-2.783.25 5.308 5.308 0 01-2.537-1.277c-1.863-1.715-2.447-4.539-2.923-7.155l-1.405-7.736 2.943 2.222c2.117 1.598 4.281 3.247 5.746 5.562 1.466 2.314 2.105 5.474.928 7.979",
  fill: "#E6E6E6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M175.089 123.685c.37-2.959.752-5.956.491-8.947-.231-2.657-.97-5.251-2.475-7.379a11.598 11.598 0 00-2.872-2.853c-.287-.199-.551.3-.265.498 1.906 1.32 3.38 3.27 4.209 5.569.917 2.555 1.064 5.342.906 8.057-.095 1.642-.298 3.273-.502 4.902a.326.326 0 00.028.217c.035.066.09.115.156.138.067.02.139.009.2-.028a.29.29 0 00.124-.174z",
  fill: "#F2F2F2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M172.423 118.937a4.22 4.22 0 01-1.528 1.508c-.619.35-1.31.52-2.006.492-1.789-.093-3.28-1.462-4.622-2.761l-3.97-3.844 2.627-.138c1.89-.099 3.828-.192 5.628.448 1.8.639 3.46 2.176 3.789 4.219",
  fill: "#E6E6E6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M176.136 125.387c-1.784-3.46-3.852-7.306-7.549-8.535a7.714 7.714 0 00-3.175-.36c-.337.032-.252.602.084.57 1.793-.163 3.582.356 5.067 1.47 1.428 1.066 2.541 2.549 3.482 4.121.577.962 1.093 1.966 1.61 2.969.165.32.648.089.481-.235z",
  fill: "#F2F2F2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M112.434 37.54v32.947h-69.4V87.98H24.685V37.54h87.748z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.887 36.668v52.188h19.146v-1.749H25.482v-48.69h86.156v32.07h1.594v-33.82H23.887z",
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M98.7 56.21H43.078v2.154H98.7V56.21zM98.7 61.808H43.078v2.153H98.7v-2.153zM98.7 67.406H43.078v2.153H98.7v-2.153zM39.701 58.774c.708 0 1.282-.63 1.282-1.405 0-.776-.574-1.405-1.282-1.405-.707 0-1.281.629-1.281 1.405s.574 1.405 1.281 1.405z",
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M88.546.873v32.946h-69.4v17.493H.798V.873h87.748z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v52.188h19.146v-1.749H1.595V1.75H87.75v32.07h1.595V0H0z",
  fill: "#F1F1F1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M74.813 19.543H19.19v2.153h55.623v-2.153zM74.813 25.14H19.19v2.154h55.623V25.14zM74.813 30.738H19.19v2.153h55.623v-2.153zM15.814 22.106c.708 0 1.282-.63 1.282-1.405 0-.776-.574-1.405-1.282-1.405-.708 0-1.281.629-1.281 1.405s.573 1.405 1.281 1.405z",
  fill: "#F1F1F1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M135.473 74.686h-87.75v50.439h87.75V74.686z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M136.271 126H46.926V73.811h89.345V126zm-87.75-1.749h86.155v-48.69H48.521v48.69z",
  fill: "#CBCBCB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M121.642 93.435H66.02v2.153h55.622v-2.153zM121.642 99.032H66.02v2.153h55.622v-2.153zM121.642 104.63H66.02v2.153h55.622v-2.153zM62.644 95.997c.707 0 1.281-.629 1.281-1.405s-.574-1.405-1.281-1.405c-.708 0-1.282.63-1.282 1.405 0 .776.574 1.405 1.282 1.405z",
  fill: "#008AF5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M122.539 73.813a2.642 2.642 0 01-.385-1.003 2.746 2.746 0 01.038-1.087c.085-.355.24-.686.454-.968.214-.282.482-.51.785-.666l6.346-21.788 4.42 2.518-7.628 20.625c.206.575.212 1.213.018 1.793a2.47 2.47 0 01-1.073 1.354 2.125 2.125 0 01-1.623.231 2.308 2.308 0 01-1.352-1.009z",
  fill: "#9F616A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M127.724 51.314a1.21 1.21 0 01.005-.938l2.173-5.124c.215-.794.707-1.462 1.37-1.858a2.63 2.63 0 012.167-.255c.725.233 1.336.771 1.699 1.497a3.4 3.4 0 01.238 2.375l-.727 5.614c-.02.16-.072.313-.152.45-.08.136-.185.252-.309.339a.976.976 0 01-.411.167.94.94 0 01-.436-.035l-4.973-1.615a1.004 1.004 0 01-.383-.231 1.105 1.105 0 01-.261-.386z",
  fill: "#EF8331"
}), /*#__PURE__*/React.createElement("path", {
  d: "M146.058 52.179l-.354 5.442-12.055 4.665-.177-5.248 12.586-4.86z",
  fill: "#9F616A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130.636 44.21l3.9-3.11 6.381-1.944 5.318 1.167.887 9.135-1.064 5.83-13.827 3.5-1.418-2.722s-3.191-3.498-.709-7.386l.532-4.47z",
  fill: "#EF8331"
}), /*#__PURE__*/React.createElement("path", {
  d: "M129.218 36.228v-5.104c0-2.16.782-4.231 2.175-5.758 1.393-1.527 3.282-2.385 5.251-2.385 1.97 0 3.859.858 5.251 2.385 1.393 1.527 2.175 3.598 2.175 5.758v5.104c0 .29-.105.568-.292.773a.957.957 0 01-.705.32h-12.858a.957.957 0 01-.705-.32 1.15 1.15 0 01-.292-.773z",
  fill: "#2F2E41"
}), /*#__PURE__*/React.createElement("path", {
  d: "M136.346 37.271c3.007 0 5.444-2.672 5.444-5.97 0-3.296-2.437-5.97-5.444-5.97s-5.445 2.674-5.445 5.97c0 3.298 2.438 5.97 5.445 5.97z",
  fill: "#9F616A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130.751 31.279a.639.639 0 01-.13-.485l.645-4.924a.642.642 0 01.103-.277.568.568 0 01.211-.19c3.292-1.69 6.63-1.691 9.922-.006a.567.567 0 01.218.201c.056.087.09.188.099.294l.431 4.93a.632.632 0 01-.142.467.555.555 0 01-.186.147.509.509 0 01-.224.052h-1.092a.518.518 0 01-.297-.095.597.597 0 01-.205-.255l-.471-1.108a.355.355 0 00-.146-.167.304.304 0 00-.207-.039.326.326 0 00-.188.107.382.382 0 00-.091.208l-.093.817a.63.63 0 01-.183.38.528.528 0 01-.367.152h-7.188a.511.511 0 01-.23-.055.556.556 0 01-.189-.154z",
  fill: "#2F2E41"
}), /*#__PURE__*/React.createElement("path", {
  d: "M154.387 71.271a2.212 2.212 0 01-.896-.47 2.478 2.478 0 01-.629-.841 2.734 2.734 0 01-.063-2.124l-8.443-20.915 4.83-1.334 6.781 20.979c.502.28.893.753 1.099 1.328a2.75 2.75 0 01.017 1.794 2.47 2.47 0 01-1.074 1.353 2.123 2.123 0 01-1.622.23z",
  fill: "#9F616A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M144.644 50.67a1.05 1.05 0 01-.352-.285 1.177 1.177 0 01-.212-.42l-1.476-5.415a3.407 3.407 0 01-.1-2.387c.256-.778.783-1.414 1.466-1.767a2.623 2.623 0 012.177-.117c.711.279 1.292.855 1.616 1.603l2.855 4.728a1.227 1.227 0 01.132.926c-.04.156-.11.3-.205.424a1.046 1.046 0 01-.348.29l-4.697 2.412a.954.954 0 01-.856.008z",
  fill: "#EF8331"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.451 122.315l-3.073-.001-1.461-12.996h4.535l-.001 12.997z",
  fill: "#9F616A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M146.235 125.581l-9.909-.001v-.137c0-1.121.407-2.197 1.13-2.99.723-.793 1.704-1.239 2.727-1.239l6.052.001v4.366z",
  fill: "#2F2E41"
}), /*#__PURE__*/React.createElement("path", {
  d: "M143.116 94.874l-2.095 2.466-9.669-7.688 3.092-3.638 8.672 8.86z",
  fill: "#9F616A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.829 96.472l-6.755 7.949-.092-.094c-.748-.765-1.189-1.824-1.225-2.945-.036-1.12.336-2.21 1.033-3.032l4.126-4.854 2.913 2.976z",
  fill: "#2F2E41"
}), /*#__PURE__*/React.createElement("path", {
  d: "M146.412 57.621l.983 1.078c4.916 5.39 6.127 12.864 5.536 20.46a23.146 23.146 0 01-.491 3.34c-1.773 7.775-.71 32.654-4.255 34.209l-.709 2.721-6.913-.28.177-2.441s-1.595-3.693-.532-6.026c1.064-2.332 3.368-19.63 3.368-19.63l-1.241-14.189-9.217 5.053s4.786 2.916 4.431 4.86c0 0 2.836.777 2.127 2.72l1.064 2.333-2.482 4.276s-16.663-10.884-15.245-16.327c1.419-5.442 10.282-9.329 10.282-9.329l.709-5.83-.611-3.178 12.402-5.227.617 1.407z",
  fill: "#2F2E41"
}), /*#__PURE__*/React.createElement("path", {
  d: "M187.773 126H86.763a.217.217 0 01-.16-.073.262.262 0 01-.067-.176c0-.067.024-.13.067-.177a.217.217 0 01.16-.073h101.01c.06 0 .118.026.161.073.042.047.066.11.066.177a.265.265 0 01-.066.176.218.218 0 01-.161.073z",
  fill: "#CBCBCB"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_729_30"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h188v126H0z"
})))));